/**
 * td-wb-notification-header
 * Header positioned at the top of notification component
 */
import {
  Component,
  input,
  InputSignal
} from '@angular/core';

export type NotificationHeaderType = 'regular' | 'note';

@Component({
  selector: 'td-wb-notification-header',
  template: '<ng-content />',
  styleUrls: ['notification-header.component.scss'],
  host: {
    '[class.td-wb-notification-header--note]': 'notificationHeaderType() === "note"'
  }
})
export class NotificationHeaderComponent {
  readonly notificationHeaderType: InputSignal<NotificationHeaderType> = input<NotificationHeaderType>('regular');
}
